import type { MedalEventState } from "@seagames/contracts";

/**
 * Games days (`YYYY-MM-DD`, the games' own calendar) — pure date arithmetic
 * on the text, at UTC noon, so no viewer's zone can move a day.
 */

const DAY = /^\d{4}-\d{2}-\d{2}$/;

export const isDay = (v: string | undefined | null): v is string => typeof v === "string" && DAY.test(v);

/** `day` plus `n` days. */
export function addDays(day: string, n: number): string {
	const t = Date.parse(`${day}T12:00:00Z`) + n * 86_400_000;
	return new Date(t).toISOString().slice(0, 10);
}

/** Whole days from `a` to `b` (`b` − `a`). */
export function daysBetween(a: string, b: string): number {
	return Math.round((Date.parse(`${b}T12:00:00Z`) - Date.parse(`${a}T12:00:00Z`)) / 86_400_000);
}

/** "Day 4 of 12": the games day number of `today` and the games' length; null outside the games or undated. */
export function gamesDayOf(today: string, startsOn: string | null, endsOn: string | null): { n: number; of: number } | null {
	if (!startsOn || !endsOn) return null;
	const n = daysBetween(startsOn, today) + 1;
	const of = daysBetween(startsOn, endsOn) + 1;
	return n >= 1 && n <= of ? { n, of } : null;
}

/** The Award medals tab an event opens in: its own list, so the queue around it is the right one. */
export function deskRouteFor(state: MedalEventState): "/award" | "/award/awarded" | "/award/no-medals" {
	return state === "AWARDED" ? "/award/awarded" : state === "NO_MEDALS" ? "/award/no-medals" : "/award";
}
